module.exports = __webpack_public_path__ + "static/media/Group 11486.38c80476.png";